import {
  Flex,
  Box,
  Text,
  RadioGroup,
  Spinner,
  ButtonGroup,
  Button,
  IconButton,
  Link,
  Tooltip,
} from "@chakra-ui/react";

import axios from "axios";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ADD_SUBSCRIPTION_TO_CART } from "../../_actions/endpoints";
import { handleHTTPError } from "../../_actions/errorHandlerActions";
import TldrBillingPlansCard from "./TldrBillingPlansCard";
import { FaArrowRight, FaChevronLeft, FaExternalLinkAlt } from "react-icons/fa";
import { SIMPLIFIED_PRICING_LINK } from "../../_utils/constants";
import { currencyFormatter } from "../../_utils/currencyFormatter";
import {
  BILLING_PLAN_INTERVAL_MONTHLY,
  BILLING_PLAN_INTERVAL_YEARLY,
} from "../../_components/details/constants";
import { openUrl } from "@simplified-workspace/shared/util";

const TldrUpgradePlanSelection = ({
  setUpgradePlanStep,
  setIsLoading,
  setCartData,
  cartData,
  onClose,
  checked,
  setChecked,
  selectedPlanId,
  setSelectedPlanId,
  resData,
  currentOrg,
  adminMember,
  subscribeToFreePlan,
  loading,
  showFeatures,
}) => {
  const { t } = useTranslation(["billing"]);

  const subscription = useSelector((state) => state.subscription);
  const isMobileView = useSelector((state) => state.app.isMobileView);

  useEffect(() => {
    if (selectedPlanId) {
      getCartItems(selectedPlanId);
    }
  }, [selectedPlanId]);

  var filteredPlans = [];
  const paidPlans = resData.payload.slice(1, resData.payload.length);
  filteredPlans = paidPlans.filter((plan) => {
    if (checked) {
      return plan.recurring?.interval === BILLING_PLAN_INTERVAL_YEARLY;
    } else {
      return plan.recurring?.interval === BILLING_PLAN_INTERVAL_MONTHLY;
    }
  });

  const childElement = filteredPlans.map((plan, index) => {
    return (
      <TldrBillingPlansCard
        key={`${index + 1}_${plan.id}`}
        planIndex={index + 1}
        plan={plan}
        yearlyInterval={checked}
        currentOrg={currentOrg}
        adminMember={adminMember}
        showSummary={true}
        selectedPlanId={selectedPlanId}
        setSelectedPlanId={setSelectedPlanId}
      />
    );
  });

  function getCartItems(planId) {
    setIsLoading(true);
    axios
      .post(ADD_SUBSCRIPTION_TO_CART, {
        plan: planId,
      })
      .then((res) => {
        setCartData(res.data);
        setIsLoading(false);
      })
      .catch((error) => {
        handleHTTPError(error);
        setIsLoading(false);
      });
  }

  function handleInterval() {
    const currentPlan = resData.payload.find(
      (plan) => plan.id === selectedPlanId
    );
    if (
      checked &&
      currentPlan.recurring.interval !== BILLING_PLAN_INTERVAL_MONTHLY
    ) {
      const foundPlan = resData.payload.find(
        (plan) =>
          plan.product.name === currentPlan.product.name &&
          plan.recurring.interval === BILLING_PLAN_INTERVAL_MONTHLY
      );
      setSelectedPlanId(foundPlan.id);
    } else {
      const foundPlan = resData.payload.find(
        (plan) =>
          plan.product.name === currentPlan.product.name &&
          plan.recurring.interval === BILLING_PLAN_INTERVAL_YEARLY
      );
      setSelectedPlanId(foundPlan.id);
    }
    setChecked(!checked);
  }

  return (
    <Flex direction={["column", "column", "column", "row"]}>
      <Flex flex={1} minH="500px">
        <Box w="full">
          <Flex align={"center"} justify="space-between">
            <Flex align={"center"} m={4}>
              {showFeatures && (
                <IconButton
                  size="sm"
                  autoFocus={false}
                  variant={"ghost"}
                  onClick={() => setUpgradePlanStep((prev) => prev - 1)}
                  fontSize="lg"
                  icon={<FaChevronLeft />}
                />
              )}
              <Text ml={4} fontSize={"lg"} fontWeight={500}>
                {t("choose_plan_and_pay_modal.title")}
              </Text>
            </Flex>
          </Flex>
          <Box
            px={4}
            pt={isMobileView ? 0 : 4}
            h={isMobileView ? "inherit" : "364px"}
          >
            <Flex h="inherit" flexWrap={isMobileView ? "wrap" : ""}>
              <Box flexGrow={1}>
                <Flex w={"full"} justify="center">
                  <ButtonGroup
                    p="1"
                    borderRadius={"full"}
                    sx={{
                      border: "1px solid",
                      borderColor: "brand.glass_light_10",
                      backgroundColor: "brand.glass_dark_08",
                    }}
                    isDisabled={!resData.loaded}
                    variant="ghost"
                    size={"sm"}
                  >
                    <Button
                      _active={{ color: "white" }}
                      _focus={{ color: "white" }}
                      onClick={handleInterval}
                      sx={
                        checked
                          ? {}
                          : {
                              backgroundColor: "brand.glass_light_10",
                              color: "white",
                            }
                      }
                      borderRadius={"full"}
                    >
                      {t("choose_plan_and_pay_modal.monthly")}
                    </Button>
                    <Button
                      _active={{ color: "white" }}
                      _focus={{ color: "white" }}
                      sx={
                        checked
                          ? {
                              backgroundColor: "brand.glass_light_10",
                              color: "white",
                            }
                          : {}
                      }
                      onClick={handleInterval}
                      borderRadius={"full"}
                    >
                      {t("choose_plan_and_pay_modal.yearly")}
                    </Button>
                  </ButtonGroup>
                </Flex>

                {!resData.loaded ? (
                  <Flex justify="center" align="center" h="296px">
                    <Spinner size="xl" color="brand.primary" />
                  </Flex>
                ) : (
                  <RadioGroup
                    value={selectedPlanId}
                    onChange={(value) => {
                      setSelectedPlanId(value);
                    }}
                    name="select_plan"
                    position={"relative"}
                  >
                    <Flex
                      gap={isMobileView ? 2 : 3}
                      mt={3}
                      mb={4}
                      flexDir={isMobileView ? "column" : "row"}
                    >
                      {childElement}
                    </Flex>
                    <Flex justify={"center"} w="full">
                      <Button
                        as={Link}
                        onClick={() =>
                          openUrl(SIMPLIFIED_PRICING_LINK, "_blank")
                        }
                        rightIcon={<FaExternalLinkAlt />}
                      >
                        {t("choose_plan_and_pay_modal.compare_plans")}
                      </Button>
                    </Flex>
                    <Flex justify={"flex-end"} w="full" mt={4}>
                      {cartData?.total && (
                        <Text fontWeight={500}>
                          {t("choose_plan_and_pay_modal.subtotal")}{" "}
                          {currencyFormatter(
                            cartData?.total,
                            subscription?.subscribedPlan?.plan?.currency
                          )}
                        </Text>
                      )}
                    </Flex>
                  </RadioGroup>
                )}
              </Box>
            </Flex>
          </Box>

          <Box p={4}>
            {loading ? (
              <Flex>
                <Spinner size={"sm"} color="gray.300" />
                <Text ml={2} fontSize="0.875rem" color="gray.300">
                  {t("subscription_in_progress", { ns: "accounts" })}
                </Text>
              </Flex>
            ) : (
              <ButtonGroup spacing={3} justifyContent="flex-end" w="full">
                {showFeatures ? (
                  <Tooltip
                    shouldWrapChildren
                    hasArrow
                    placement="bottom"
                    label={
                      currentOrg?.members_count > 1
                        ? t("free_plan_info", { ns: "accounts" })
                        : !adminMember?.is_admin && !adminMember?.is_primary
                        ? t("switch_account", { ns: "accounts" })
                        : null
                    }
                  >
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        subscribeToFreePlan();
                      }}
                      variant="ghost"
                      color="gray.100"
                      isDisabled={
                        currentOrg?.members_count > 1 ||
                        (!adminMember?.is_admin && !adminMember?.is_primary)
                      }
                    >
                      {t("continue_free_plan", { ns: "accounts" })}
                    </Button>
                  </Tooltip>
                ) : (
                  <Button onClick={onClose} variant="ghost" color="gray.100">
                    {t("choose_plan_and_pay_modal.cancel_btn")}
                  </Button>
                )}
                <Button
                  variant="solid"
                  rightIcon={<FaArrowRight />}
                  onClick={() => setUpgradePlanStep((prev) => prev + 1)}
                >
                  {t("choose_plan_and_pay_modal.checkout_btn")}
                </Button>
              </ButtonGroup>
            )}
          </Box>
        </Box>
      </Flex>
    </Flex>
  );
};

export default TldrUpgradePlanSelection;
